import { render, staticRenderFns } from "./AppraisalRecordNew.vue?vue&type=template&id=1f9401e2"
import script from "./AppraisalRecordNew.vue?vue&type=script&lang=js"
export * from "./AppraisalRecordNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports